import AppCommandBar from 'app/AppCommandBar'
import { FlexSpinner } from 'components'
import { ViewAuthorizer } from 'components/AccessDenied'
import { StickyPane } from 'components/StickyPane'
import { useShowCommand } from 'hooks/useCommand'
import useSelection from 'hooks/useSelection'
import { Proving, UserRole } from 'model'
import React from 'react'
import { useRouter } from 'react-router5'
import { BookingsManagerList } from './BookingsManagerList'
import {
    useReadProvingsForBookingManagerDateViewQuery,
    useReadProvingsForBookingManagerListQuery,
} from './BookingsView.generated'

export const BookingsManagerDateView: React.FunctionComponent = () => {
  const { loading, data, error } =
    useReadProvingsForBookingManagerDateViewQuery({
      variables: {
        status: [8, 9],
      },
    })

  const router = useRouter()

  const showProving = React.useCallback(
    (proving: Partial<Proving>) => {
      router.navigate('provings.details', { id: proving.id })
    },
    [router]
  )
  const [selection, selectedItems] = useSelection<Partial<Proving>>({
    getKey: (item) => item!.id!,
  })

  useShowCommand(
    { name: 'proving', count: selectedItems.length },
    {
      priority: 20,
      onClick: () => showProving(selectedItems[0]),
    },
    [selectedItems]
  )

  const provings = data && data.provings ? data.provings : []
  return (
    <ViewAuthorizer
      roles={[
        UserRole.Maintenancehead,
        UserRole.ProvingOrganisation,
        UserRole.Reader,
        UserRole.ResourceManager,
        UserRole.ServiceTeam,
        UserRole.SystemAdministrator,
        UserRole.ProvingCreator,
        UserRole.User,
      ]}
    >
      <StickyPane>
        <FlexSpinner loading={loading} error={error}>
          <AppCommandBar />
          <BookingsManagerList
            items={provings}
            selection={selection}
            onItemInvoked={showProving}
          />
        </FlexSpinner>
      </StickyPane>
    </ViewAuthorizer>
  )
}

const BookingsManagerArchiveListView: React.FunctionComponent = () => {
  const { loading, data, error } = useReadProvingsForBookingManagerListQuery({
    variables: {
      status: 8,
    },
  })
  const router = useRouter()

  const showProving = React.useCallback(
    (proving: Partial<Proving>) => {
      router.navigate('provings.details', { id: proving.id })
    },
    [router]
  )
  const [selection, selectedItems] = useSelection<Partial<Proving>>({
    getKey: (item) => item!.id!,
  })
  useShowCommand(
    { name: 'proving', count: selectedItems.length },
    {
      priority: 20,
      onClick: () => showProving(selectedItems[0]),
    },
    [selectedItems]
  )

  const provings = data && data.provings ? data.provings : []

  return (
    <ViewAuthorizer
      roles={[
        UserRole.Maintenancehead,
        UserRole.ProvingOrganisation,
        UserRole.Reader,
        UserRole.ResourceManager,
        UserRole.ServiceTeam,
        UserRole.SystemAdministrator,
        UserRole.ProvingCreator,
        UserRole.User,
      ]}
    >
      <StickyPane>
        <FlexSpinner loading={loading} error={error}>
          <BookingsManagerList
            items={provings}
            selection={selection}
            onItemInvoked={showProving}
          />
        </FlexSpinner>
      </StickyPane>
    </ViewAuthorizer>
  )
}

export const BookingsManagerArchiveView: React.FC = () => (
  <>
    <ViewAuthorizer
      roles={[
        UserRole.Maintenancehead,
        UserRole.ProvingOrganisation,
        UserRole.Reader,
        UserRole.ResourceManager,
        UserRole.ServiceTeam,
        UserRole.SystemAdministrator,
        UserRole.ProvingCreator,
        UserRole.User,
      ]}
    >
      <StickyPane>
        <AppCommandBar />
        <BookingsManagerArchiveListView />
      </StickyPane>
    </ViewAuthorizer>
  </>
)
